export const errorNoComponent = (contentType = 'unknown') =>
  `Could not find layout component for content type ${contentType}`
